import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosService from '../../../utility/axiosService/axiosService'
import { API_ENDPOINT } from '../../../utility'
import { toast } from "react-toastify"

export const getAdminUserProfile = createAsyncThunk(
    'users/getAdminUserProfile',
    async () => {
        return await axiosService.get(`${API_ENDPOINT}/admin/admin-profile`).then((res) => {
            return res.data;
        });
    }
);


const adminProfileSlice = createSlice({
    name: 'orders',
    initialState: {
        loading: false,
        data: [],
        error: null,
    },
    reducers: {
    },
    extraReducers: {
        [getAdminUserProfile.pending]: (state) => {
            state.loading = true;
        },
        [getAdminUserProfile.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload.data;
        },
    }
});


export default adminProfileSlice.reducer;